export default {
  state: {
    id: undefined,
    active: true,
    active_subscriber: false,
    admin: true,
    private: true,
    receive_targeted_emails: undefined,
    email: undefined,
    email_suspended: false,
    email_suspension_reason: undefined,
    last_errored_record: undefined,
    latest_email_error: {},
    name: undefined,
    newsletter_type_subscriptions: [],
    unsubscribed_providers: [],
    password_reset_requested: false,
    username: undefined,
    created_at: undefined,
    updated_at: undefined,
    relationships: {},
    role: {},
    role_id: undefined,
    roles: [],
    role_name: undefined,
    invited_at: undefined,
    invited_by: undefined,
    invitation_accepted_at: undefined,
    loading: false,
    inviter: {},
    user_detail: {}
  }
}



// WEBPACK FOOTER //
// ./src/stores/UserStore.js